export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  catalogo(state) {
    return state.catalogo;
  },
  hasFilters(state) {
    return state.catalogo;
  },
  stringFilter(state) {
    let filter = '';
    if (state.searchText) {
      filter += `(titulo like '%${state.searchText.toLowerCase()}%' or especificacao like '%${state.searchText.toLowerCase()}%' or codigo like '%${state.searchText.toLowerCase()}%')`;
    }
    if (state.catalogo) {
      const catalogoFilter = `(catalogo.id = ${state.catalogo.id})`;
      if (filter) {
        filter = `${filter} and ${catalogoFilter}`;
      } else {
        filter = catalogoFilter;
      }
    }
    return filter;
  },
};
